exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-table .ui-datatable-tablewrapper table tr th {\n  width: 2%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/contact-table/contact-table.component.scss
// module id = ../../../../../resources/assets/src/app/shared/modules/contact-table/contact-table.component.scss
// module chunks = main